const toolNames = [
  {
    slug: 'T01',
    name: 'SAT basin infiltration capacity reduction database',
  },
  {
    slug: 'T02',
    name: 'Groundwater mounding (Hantush)',
  },
  {
    slug: 'T03',
    name: 'Numerical groundwater modelling and optimization',
  },
  {
    slug: 'T04',
    name: 'Database for GIS-based suitability mapping',
  },
  {
    slug: 'T05',
    name: 'GIS multi-criteria decision analysis',
  },
  {
    slug: 'T06',
    name: 'MAR method selection',
  },
  {
    slug: 'T07',
    name: 'MODFLOW model scenario manager',
  },
  {
    slug: 'T08',
    name: '1D transport equation (Ogata-Banks)',
  },
  {
    slug: 'T09A',
    name: 'Depth of saltwater interface',
  },
  {
    slug: 'T09B',
    name: 'Freshwater-saltwater interface',
  },
  {
    slug: 'T09C',
    name: 'Upconing',
  },
  {
    slug: 'T09D',
    name: 'Critical well discharge',
  },
  {
    slug: 'T09E',
    name: 'Sea level rise (vertical cliff)',
  },
  {
    slug: 'T09F',
    name: 'Sea level rise (inclined coast)',
  },
  {
    slug: 'T10',
    name: 'Real time monitoring',
  },
  {
    slug: 'T11',
    name: 'MAR model selection',
  },
  {
    slug: 'T13A',
    name: '',
  },
  {
    slug: 'T13B',
    name: '',
  },
  {
    slug: 'T13C',
    name: '',
  },
  {
    slug: 'T13D',
    name: '',
  },
  {
    slug: 'T13E',
    name: '',
  },
  {
    slug: 'T14A',
    name: 'Fully penetrating stream with no streambed resistance',
  },
  {
    slug: 'T14B',
    name: 'Fully penetrating stream with semipervious layer',
  },
  {
    slug: 'T14C',
    name: 'Partially penetrating stream with streambed resistance',
  },
  {
    slug: 'T14D',
    name: 'Partially penetrating stream in an aquitard overlying a pumped aquifer',
  },
  {
    slug: 'T15',
    name: 'Quantitative microbial risk assessment',
  },
  {
    slug: 'T17',
    name: 'Global MAR portal',
  },
  {
    slug: 'T18',
    name: 'SAT basin design',
  },
  {
    slug: 'T19',
    name: 'Heat transport',
  },
  {
    slug: 'T20',
    name: 'Real time modelling',
  },
  // {
  //   slug: 'T100',
  //   name: 'MarPro - Scenario Editor',
  // },
  // {
  //   slug: 'marpro',
  //   name: 'MarPro - Game'
  // }
];

export default toolNames;
